import http from "@/services/http";
import {TRANSACTION_URL} from "@/services/endpoints";

export function  getTransactionList(params) {
  return http.request({
    url:TRANSACTION_URL,
    method:'get',
    params
  })
}
export function createTransaction(postData){
  return http.request({
    url:TRANSACTION_URL,
    method:'post',
    data:postData
  })
}
export function updateTransaction(id,postData){
  return http.request({
    url:TRANSACTION_URL+`/${id}`,
    method:'put',
    data:postData
  })
}
export function deleteTransaction(id){
  return http.request({
    url:TRANSACTION_URL+`/${id}`,
    method:'delete',
  })
}
